export default "__VITE_ASSET__BnYb3uNQ__"